import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/banners")({
  component: lazyRouteComponent(() => import("./-pages/admin.banners")),
  head: () => ({
    meta: [{ title: "Banners · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
